import { render, staticRenderFns } from "./TechnicalReports.vue?vue&type=template&id=2c020cc7&"
import script from "./TechnicalReports.vue?vue&type=script&lang=js&"
export * from "./TechnicalReports.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports